<template>
  <div class="text-dark pt-6 pb-3">
    <h2 class="mb-3 pb-2 font-weight-semi-bold">Services</h2>

    <h3 class="h4 mb-2 font-weight-semi-bold">Quantity of services</h3>
    <div class="audit-chart">
      <div class="full">
        <div class="competitors-chart-column">
          <div v-for="({ id, name, total, matched }, index) in competitorsServices"
            :key="index"
            :class="['competitors-chart-column-point--container text-center', `w-${Math.floor(100/competitorsServices.length)}`]">
            <span class="font-weight-bold mb-2">
              <span :class="{'text-grey': total === 0}">{{ total }} /</span>
              {{ matched }}
            </span>
            <div class="competitors-chart-column-point">
              <div class="competitors-chart-column-point competitors-chart-column-point--value"
                :style="`height: ${(total - matched) / maxCount * 100}%`" />
              <div class="competitors-chart-column-point competitors-chart-column-point--value-green"
                :style="`height: ${ matched / maxCount * 100}%`" />
            </div>
            <hr class="m-0 w-100 mb-2">
            <span class="competitors-chart-column-point-title text-primary cursor-pointer px-3"
              :title="name"
              @click="showContentSidebar({ id, name }, 'services')">
              {{ name }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="competitors-chart-legend">
      <div class="competitors-chart-legend-item">
        <div class="point blue" />
        Total quantity
      </div>
      <div class="competitors-chart-legend-item">
        <div class="point green" />
        Matched services
      </div>
    </div>
  </div>
</template>

<script>
import showContentSidebarMixin from './show_content_sidebar_mixin'

export default {
  mixins: [showContentSidebarMixin],
  props: {
    sectionData: { type: Object, required: true }
  },
  created() {
    this.maxCount = 1
    this.competitorsServices = [
      { competitor: 'My location', gbpServices: this.sectionData.current },
      ...this.sectionData.competitors
    ].map(({ competitor, gbpServices: [total, matched], ...rest }) => {
      if (this.maxCount < total) this.maxCount = total

      return {
        name: competitor,
        total,
        matched,
        ...rest
      }
    })
  }
}
</script>
